import { Link } from 'react-router-dom';
import Button from '../../atoms/button/button.atom';
import mainBG from '../../jpeg/pages/home/3.jpg';
// import { Button, Input } from 'antd';
import Search from 'antd/es/transfer/search';
import { MainHeaderContainer } from './main-header.styles';

// const { Search } = Input;

const MainHeader = ({img, text1, text2, subtitle, buttonText }) => {
    return (
        <MainHeaderContainer>
            <div className='main-header-box'>
                <div className='main-visual'  style={{
                    backgroundImage: `url(${mainBG})`,
                }}></div>
                <div className='main-text'>
                    <h2>{text1}</h2>
                    <h2>{text2}</h2>
                    {/* <p>EVERYTHING YOU NEED TO START AND SCALE UP YOUR ECOMMERCE BUSINESS</p> */}
                    {/* <Link to="../services" style={{ 
						textDecoration: 'inherit',
						color: 'inherit'
					}}>
                       <Button styles={{
                        fontSize: '2em',
                        width: '100%',
                       }} text='TALK TO AN EXPERT' />
                    </Link> */}
                </div>
            </div>
        </MainHeaderContainer>
    )
}

export default MainHeader;